import useEntity from "../../hooks/useUserSession";
import UserSessionDetail from "../../components/userSession/UserSessionDetail/UserSessionDetail";
import UserSessionScoped from "../../components/userSession/UserSessionDetail/UserSessionScoped";
import UserSessionTabs from "../../components/userSession/UserSessionDetail/UserSessionTabs";
import { useGetUserSessionQuery } from "../../apis/UserSession.api";
import { PrimaryUserSession } from "../../types/models/UserSession";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserSessionDetailPage = () => {

    useTitle(t`Details User Session`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { userSessionId: id } = useParams();

    const { data, refetch } = useGetUserSessionQuery(PrimaryUserSession.fromPath(id))
    const { deleteUserSession } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteUserSession(data, '..')
    }, [data, deleteUserSession])

    if (id === 'scoped') {
        return (<UserSessionScoped/>)
    }

    return (
        <Box data-testid="UserSession-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <UserSessionDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/UserSessions/update/view') &&
                        <Button size="small" variant="outlined" data-testid="UserSession-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { 
        session.hasPermission('', 'applications/auth/entities/UserSessions/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="UserSession-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <UserSessionTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default UserSessionDetailPage;
